import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedPropertyData, ITrackedProperty} from "./tracked_utils/tracked_property";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";
import {pageviewAlgolytics} from "./offer_detail_pageview";

export const propertyDetailPageview = (
    property: ITrackedProperty & {
        price: number | null;
        price_m2: number;
    },
    offer: ITrackedOffer,
    vendor: ITrackedVendor
) => {
    const payload = {
        view_type: "property",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer),
        ...getTrackedPropertyData(property),
        property_price_m2: property.price_m2,
        property_price: property.price
    };
    pageviewAlgolytics(payload);
};
import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedPropertyData, ITrackedProperty} from "./tracked_utils/tracked_property";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";
import {pageviewAlgolytics} from "./offer_detail_pageview";

export const propertyDetailPageview = (
    property: ITrackedProperty & {
        price: number | null;
        price_m2: number;
    },
    offer: ITrackedOffer,
    vendor: ITrackedVendor
) => {
    const payload = {
        view_type: "property",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer),
        ...getTrackedPropertyData(property),
        property_price_m2: property.price_m2,
        property_price: property.price
    };
    pageviewAlgolytics(payload);
};
